var _defs, _text, _circle, _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290.54 181.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{font-size:135.48px;fill:#a5c3e6;font-family:HeadlineR-HM, Headline R;}.b,.c,.d{fill:none;stroke:#494949;stroke-miterlimit:10;}.b,.c{stroke-width:8.69px;}.c,.d{stroke-linecap:round;}.d{stroke-width:4.34px;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(0 116.43)"
  }, "404")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 169.69,
    cy: 77.86,
    r: 50.33
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 205.58,
    y1: 125.68,
    x2: 256.74,
    y2: 176.84
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M207.31,151.38a33.42,33.42,0,0,0-32.89-27.48",
    transform: "translate(-4.73 -79.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M174.42,190.72a33.42,33.42,0,0,0,33.05-28.49",
    transform: "translate(-4.73 -79.35)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.07bbe4cbbe2695f948425f23c0ec125b.svg";
export { ForwardRef as ReactComponent };